import { render, staticRenderFns } from "./ForestersMasterclass1EN.vue?vue&type=template&id=c35edef8&scoped=true"
import script from "./ForestersMasterclass1EN.vue?vue&type=script&lang=js"
export * from "./ForestersMasterclass1EN.vue?vue&type=script&lang=js"
import style0 from "./ForestersMasterclass1EN.vue?vue&type=style&index=0&id=c35edef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35edef8",
  null
  
)

export default component.exports